import ForgotPasswordModalProvider from './ForgotPasswordModalProvider';

window.tnew.page.initialize = ({ autoShowForgotPasswordModal }) => {
  const forgotPasswordModalProvider = new ForgotPasswordModalProvider(autoShowForgotPasswordModal);

  forgotPasswordModalProvider.listen();
};



// WEBPACK FOOTER //
// ./V7/account/login/account-login.js